import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "tooltip", "truncateStringProps", "as", "cssStyles", "colSpan", "rowSpan", "headers"];
import { Component } from 'react';
import { Media } from '../Media';
import { MediaBody } from '../MediaBody';
import { MediaRight } from '../MediaRight';
import { TruncateString } from '../TruncateString';
import { TableHoverContent } from './TableHoverContent';
import { filterProps } from '../../../utils/filterProps';
import styled from 'foundations-theming/utils';
import { withTokenProps } from '../../../utils/withTokenProps';
import { CSS_SPECIFICITY } from '../../constants';
import { screenReaderOnlyTokenProps } from '../../utils/styles/styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledTableHoverCell = styled.td.withConfig({
  displayName: "TableHoverCell__StyledTableHoverCell",
  componentId: "sc-1lvvhff-0"
})(({
  $cssStyles
}) => {
  return {
    [CSS_SPECIFICITY.FORCE_OVERRIDE]: Object.assign({}, $cssStyles)
  };
});
export class TableHoverCellComponent extends Component {
  constructor(props) {
    super(props);
    this.handleHoverContentOpenChange = evt => {
      const rowIsHovered = evt.target.value;
      if (!rowIsHovered !== this.state.hoverContentIsClosing) {
        // Remove hover content's left margin while closing (#2412)
        this.setState({
          hoverContentIsClosing: !rowIsHovered
        });
      }
      this.setState({
        rowIsHovered
      });
    };
    this.handleTooltipOpenChange = evt => {
      this.setState({
        tooltipIsOpen: !!evt.target.value
      });
    };
    this.renderHoverContent = () => {
      const {
        hoverContent,
        hoverContentProps
      } = this.props;
      const {
        hoverContentIsClosing,
        rowIsHovered,
        tooltipIsOpen
      } = this.state;
      const open = hoverContentProps && hoverContentProps.open || rowIsHovered || tooltipIsOpen;
      if (!hoverContent) {
        return null;
      }
      return /*#__PURE__*/_jsx(MediaRight, Object.assign({
        marginInlineStart: hoverContentIsClosing && !open ? '0 !important' : undefined,
        minInlineSize: "auto"
      }, !open && screenReaderOnlyTokenProps, {
        children: /*#__PURE__*/_jsx(TableHoverContent, Object.assign({
          open: open,
          onOpenChange: this.handleHoverContentOpenChange,
          shrinkOnHide: true
        }, hoverContentProps, {
          children: hoverContent
        }))
      }));
    };
    const {
      hoverContentProps: _hoverContentProps
    } = props;
    const _rowIsHovered = _hoverContentProps ? !!_hoverContentProps.open : false;
    this.state = {
      rowIsHovered: _rowIsHovered,
      hoverContentIsClosing: false,
      tooltipIsOpen: false
    };
  }
  render() {
    const _this = this,
      {
        props: {
          children,
          tooltip = true,
          truncateStringProps,
          as: OuterElement = 'td',
          cssStyles,
          colSpan,
          rowSpan,
          headers
        },
        state: {
          rowIsHovered,
          tooltipIsOpen
        }
      } = _this,
      rest = _objectWithoutPropertiesLoose(_this.props, _excluded);
    const {
      domProps,
      callbackProps
    } = filterProps(rest);
    return /*#__PURE__*/_jsx(StyledTableHoverCell, Object.assign({
      as: OuterElement
    }, domProps, callbackProps, {
      $cssStyles: cssStyles,
      colSpan: colSpan,
      rowSpan: rowSpan,
      headers: headers,
      children: /*#__PURE__*/_jsxs(Media, {
        align: "center",
        blockSize: "100%",
        children: [/*#__PURE__*/_jsx(MediaBody, {
          children: /*#__PURE__*/_jsx(TruncateString, Object.assign({
            open: tooltipIsOpen
          }, truncateStringProps, {
            "data-content-hovered": rowIsHovered,
            tooltip: tooltip,
            onOpenChange: this.handleTooltipOpenChange,
            children: children
          }))
        }), this.renderHoverContent()]
      })
    }));
  }
}
export const TableHoverCell = withTokenProps(TableHoverCellComponent);
TableHoverCell.displayName = 'TableHoverCell';